import Axios from "axios";
import { BaseService } from "./BaseService";
import { Constantes } from "@/Util/Constantes";
import { TraduccionFiltro, TraduccionTablaMaestra, TraduccionTablaMaestraFiltro, TraduccionTexto } from "@/model/Traduccion";
import { AuthService } from "./Auth";
import store from "@/store";

const RESOURCE_NAME = "/Traduccion";

export class TraduccionService {
    public static loadAxios(): void {

        Axios.interceptors.request.use(
            function (config) {
                let user = AuthService.getUsuario();
                let empresa = user?.id_empresa_seleccionado;
                let token = "";

                if (user)
                    token = user.token;                    
                if (token) config.headers.Authorization = `Bearer ${token}`;
                else config.headers.Authorization = null;
               
                if(empresa) config.headers.empresa = empresa;
               
                // config.headers.Authorization = null;
                return config;
            },
            function (error) {
                // Do something with request error
                return Promise.reject(error);
            }
        );

        Axios.interceptors.response.use(
            function (response) {
                // Any status code that lie within the range of 2xx cause this function to trigger
                // Do something with response data
                return response;
            },
            function (error) {
                // if (error.response.status == 401) AuthService.limparToken();
                // Any status codes that falls outside the range of 2xx cause this function to trigger
                // Do something with response error
                return Promise.reject(error);
            }
        );

        //console.log(Axios.defaults.baseURL)
        //console.log(store.state.API_ENDPOINT)


        // al entrar en la pagina viene vacio
        Axios.defaults.baseURL = store.state.API_ENDPOINT;

        if (!Axios.defaults.baseURL)
            Axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        //console.log(Axios.defaults.baseURL)
        // if (Axios.defaults.baseURL == undefined || Axios.defaults.baseURL == null || Axios.defaults.baseURL == ''){
        //     Axios.defaults.baseURL = Constantes.URL_BASE_API;
        // }

        //Axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    }


    public static async getTraduccionesYTareas(filtro: TraduccionFiltro) {
        this.loadAxios();
        return await Axios.post(`admin/traduccion_tarea`, filtro);        
    }

    public static async getTagsPagina(filtro: TraduccionFiltro) {
        this.loadAxios();
        return await Axios.post(`${Constantes.RUTA_TRADUCCION}/tags/pagina`, filtro);        
    }
    
    public static async actualizarTraducciones(filtro: TraduccionFiltro) {
        this.loadAxios();
        return await Axios.post(`${Constantes.RUTA_TRADUCCION}/verificar`, filtro);
    }
    
    public static async getTraduccionIdioma(filtro: TraduccionTexto) {
        return await Axios.post(`${RESOURCE_NAME}/textos`,filtro);        
    }

    public static async actualizarTexto(listaTextos: Array<TraduccionTexto>) {
        this.loadAxios();
        return await Axios.put(`${RESOURCE_NAME}/textos`, listaTextos);
    }

    public static async getTablaGenericaAsync(filtro: TraduccionTablaMaestraFiltro) {
        this.loadAxios();
        return await Axios.post(`${RESOURCE_NAME}/tablas_genericas`,filtro);        
    }

    public static async grabarTablaGenerica(tablaMaestra: TraduccionTablaMaestra) {
        this.loadAxios();
        return await Axios.post(`${RESOURCE_NAME}/tabla_generica`, tablaMaestra);
    }

    public static async actualizarTablaGenerica(tablaMaestra: TraduccionTablaMaestra) {
        this.loadAxios();
        return await Axios.put(`${RESOURCE_NAME}/tabla_generica`, tablaMaestra);
    }

    public static async getTraducionTablaAsync(filtro: TraduccionTexto) {
        this.loadAxios();
        return await Axios.post(`${RESOURCE_NAME}/tabla`,filtro);        
    }
    
    public static async actualizarTraducionTablaAsync(listaTextos: Array<TraduccionTexto>) {
        this.loadAxios();
        return await Axios.put(`${RESOURCE_NAME}/tabla`, listaTextos);
    }
}